import root from "window-or-global";
import type {MarketConfig, MarketProduct} from "./types";
import getMarketFromEnv, {isValidMarket} from "./getMarketFromEnv";

export * from "./types";

declare global {
    // eslint-disable-next-line vars-on-top, no-var
    var marketConfig: MarketConfig;
}

/**
 * Get the config for the current market
 * @returns market config object for current market
 */
const getMarketConfig = () => root.marketConfig;

/**
 * Returns marketValues for the given product from the market-config.
 * @param {MarketProduct} product - The product to retrieve from marketValues.
 * @returns {any} The value for the given product, or null if not found.
 */
function getMarketValues(product: MarketProduct) {
    return getMarketConfig().marketValues[product] || null;
}

export {getMarketConfig, getMarketFromEnv, isValidMarket, getMarketValues};
